// 📁 components/categoria/RepresentanteItem.js - CORREGIDO
import React from "react";
import {
  Grid,
  Box,
  Typography,
  Avatar,
  Chip,
  Card,
  CardContent
} from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { RepresentanteRow, theme } from "../../styles/CategoriaStyles";
import { 
  getNombreDepartamento, 
  getNombreMunicipio,
  getNombreAsociacion  // ← AGREGADO IMPORT
} from "../../utils/categoriaHelpers";

// Componente para vista de lista/fila
export const RepresentanteRowItem = ({ 
  representante, 
  categoria, 
  departamentos = [], 
  municipios = [] 
}) => {
  const categoriaRep = representante.categorias?.find((cat) => cat.Id === categoria.Id && cat.Estado !== 'Inactivo');

  return (
    <RepresentanteRow>
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={12} md={4}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Avatar 
              src={representante.fotografia || ""} 
              sx={{ 
                width: 50, 
                height: 50, 
                border: `2px solid ${theme.palette.accent.light}` 
              }}
            >
              {representante.nombre_representante?.charAt(0) || "R"}
            </Avatar>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {representante.nombre_representante}
              </Typography>
              <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                DNI: {representante.dni}
              </Typography>
            </Box>
          </Box>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Box sx={{ 
            display: "flex", 
            alignItems: "center", 
            gap: 2, 
            justifyContent: { xs: "flex-start", md: "center" } 
          }}>
            {categoriaRep?.Cargo && (
              <Chip 
                icon={<WorkIcon />} 
                label={categoriaRep.Cargo} 
                variant="outlined" 
                sx={{ 
                  borderColor: theme.palette.accent.main, 
                  color: theme.palette.accent.main 
                }} 
              />
            )}
          </Box>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Box sx={{ 
            display: "flex", 
            alignItems: "center", 
            gap: 2, 
            justifyContent: { xs: "flex-start", md: "flex-end" } 
          }}>
            <Chip 
              icon={<LocationOnIcon />} 
              label={`${getNombreDepartamento(departamentos, representante.cod_depto)} - ${getNombreMunicipio(municipios, representante.cod_municipio)}`} 
              variant="outlined" 
              sx={{ 
                borderColor: theme.palette.primary.main, 
                color: theme.palette.primary.main 
              }} 
            />
          </Box>
        </Grid>
      </Grid>
    </RepresentanteRow>
  );
};

// Componente para vista de card (Junta Directiva)
export const RepresentanteCard = ({ 
  representante, 
  cargoLabel, 
  isMain = false 
}) => (
  <Card sx={{
    width: isMain ? { xs: 200, md: 260 } : { xs: 180, md: 220 },
    m: 1.5, 
    borderRadius: "12px",
    border: isMain 
      ? `2px solid ${theme.palette.primary.main}` 
      : `1px solid ${theme.palette.primary.main}`,
    boxShadow: isMain 
      ? "0 6px 24px rgba(67, 41, 24, 0.2)" 
      : "0 4px 16px rgba(67, 41, 24, 0.1)",
  }}>
    <CardContent sx={{ textAlign: "center", p: 1.5 }}>
      <Avatar 
        src={representante?.fotografia || ""} 
        sx={{ 
          width: isMain ? 80 : 60, 
          height: isMain ? 80 : 60, 
          mx: "auto", 
          mb: 1,
          border: `3px solid ${theme.palette.primary.main}` 
        }}
      >
        {representante?.nombre_representante?.charAt(0) || "R"}
      </Avatar>
      
      <Typography 
        variant={isMain ? "subtitle1" : "body1"} 
        sx={{
          fontWeight: 700, 
          color: theme.palette.text.primary, 
          mb: 0.5,
          fontSize: isMain 
            ? { xs: "0.9rem", md: "1rem" } 
            : { xs: "0.8rem", md: "0.9rem" },
        }}
      >
        {representante?.nombre_representante || "Sin asignar"}
      </Typography>
      
      <Chip 
        label={cargoLabel} 
        size="small" 
        sx={{
          backgroundColor: theme.palette.primary.main, 
          color: "#FFF", 
          fontWeight: 600, 
          mb: 0.5,
          fontSize: isMain 
            ? { xs: "0.7rem", md: "0.75rem" } 
            : { xs: "0.65rem", md: "0.7rem" },
        }} 
      />
      
      {representante && (
        <Typography 
          variant="caption" 
          sx={{ 
            color: theme.palette.text.secondary, 
            display: "block",
            fontSize: { xs: "0.6rem", md: "0.65rem" }
          }}
        >
          DNI: {representante.dni || "N/A"}
        </Typography>
      )}
    </CardContent>
  </Card>
);

// Componente para tabla (Modal/Lista completa)
export const RepresentanteTableRow = ({ 
  representante, 
  categoria, 
  asociaciones = [], 
  departamentos = [] 
}) => {
  const categoriaRep = representante.categorias?.find((cat) => cat.Id === categoria.Id && cat.Estado !== 'Inactivo');
  
  return (
    <>
      <td style={{ textAlign: "center", padding: "16px" }}>
        <Avatar 
          src={representante.fotografia || ""} 
          sx={{ 
            width: 40, 
            height: 40, 
            mx: "auto",
            border: `2px solid ${theme.palette.primary.main}` 
          }}
        >
          {representante.nombre_representante?.charAt(0) || "R"}
        </Avatar>
      </td>
      <td style={{ fontWeight: 600, textAlign: "center", padding: "16px" }}>
        {representante.nombre_representante || "Sin nombre"}
      </td>
      <td style={{ textAlign: "center", padding: "16px" }}>
        {representante.dni || "Sin DNI"}
      </td>
      <td style={{ textAlign: "center", padding: "16px" }}>
        <Chip 
          label={categoriaRep?.Cargo || ""} 
          size="small" 
          sx={{ 
            backgroundColor: theme.palette.accent.light, 
            color: theme.palette.primary.main 
          }} 
        />
      </td>
      <td style={{ textAlign: "center", padding: "16px" }}>
        {getNombreAsociacion(asociaciones, representante.cod_asociacion)}
      </td>
      <td style={{ textAlign: "center", padding: "16px" }}>
        {getNombreDepartamento(departamentos, representante.cod_depto)}
      </td>
    </>
  );
};

export default RepresentanteRowItem;